module.exports = __webpack_public_path__ + "appearance/images/Composer-Uploads-Step1.png";